import { get  } from 'ajax.js';
import moment from 'moment';
import isProduction from 'is_production.js';

const SESSION_TIMEOUT = 1200000; // 20 min

// Called by bootstrap.js whenever we mount the react app
export function scheduleAutomaticLogoutTimers() {
  if (isProduction()) {
    setTimeout(logoutOrScheduleNextCheck, SESSION_TIMEOUT + 1000)
    window.NEXT_SESSION_TIMEOUT_TIME = (moment().valueOf()) + SESSION_TIMEOUT + 1000;

    // During normal browser behavior, we should not need to ever manually check if
    // we need to logout, as the scheduled automatic logout timers above should
    // handle it.
    // But in the case of mobile phones sleeping, mobile browsers pause ticking our
    // scheduled timers, and we may wake the browser when the user's session is
    // expired on the server, but the browser won't check for another twenty
    // minutes.
    // So check if we need to logout whenever the tab gains visibility, which will
    // run after the user wakes their phone and opens the browser.
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        logoutIfNecessary();
      }
    });
  }
}

async function logoutOrScheduleNextCheck() {
  const timeout = await getSessionTimeoutOrLogout();
  if (timeout) {
    setTimeout(logoutOrScheduleNextCheck, timeout);
  }
}

async function getSessionTimeoutOrLogout() {
  const res = await get('/session', {});

  if (res.session && res.session.loggedIn) {
    const timeoutTimestamp = (res.session.sessionTimeout + 1) * 1000;
    window.NEXT_SESSION_TIMEOUT_TIME = timeoutTimestamp;

    const timeout = timeoutTimestamp - moment().valueOf()
    return timeout;
  } else {
    // This will kick the user out to /login,
    // but not until saving the "attempted url"
    window.onbeforeunload = null;
    window.location.reload()
  }
}

// Finally, as a backup to the backup, also export this function to allow
// manually calling it elsewhere.
// It will not make a network request most of the time, because the scheduled
// logout checks will have set NEXT_SESSION_TIMEOUT_TIME to the future or
// logged us out already, and if it does make a network request it is likely we
// actually do need to logout.
export async function logoutIfNecessary() {
  if (!isProduction()) return false;

  if (moment().valueOf() < window.NEXT_SESSION_TIMEOUT_TIME) {
    return false;
  }

  return (await getSessionTimeoutOrLogout());
}
